function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Content from '@nextcloud/vue/dist/Components/Content';
import AppContent from '@nextcloud/vue/dist/Components/AppContent';
import EmptyContent from '@nextcloud/vue/dist/Components/EmptyContent';
import Breadcrumbs from '@nextcloud/vue/dist/Components/Breadcrumbs';
import Breadcrumb from '@nextcloud/vue/dist/Components/Breadcrumb';
import Navigation from './../components/Navigation';
import Table from './../components/Table';
import Sidebar from './../components/Sidebar';
import { mapGetters, mapActions } from 'vuex';
import { RadioBrowserApi } from './../services/RadioBrowserApi';
var apiClient = new RadioBrowserApi();
export default {
  name: 'Main',
  components: {
    Navigation: Navigation,
    Content: Content,
    AppContent: AppContent,
    Table: Table,
    EmptyContent: EmptyContent,
    Sidebar: Sidebar,
    Breadcrumbs: Breadcrumbs,
    Breadcrumb: Breadcrumb
  },
  data: function data() {
    return {
      pageLoading: false,
      blurHashes: require('../assets/blurHashes.json'),
      showSidebar: false,
      sidebarStation: {},
      tableData: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['favorites', 'recent', 'isFavorite'])), {}, {
    stations: function stations() {
      if (this.$route.name === 'RECENT') {
        return this.recent;
      }

      return this.tableData;
    },
    emptyContentMessage: function emptyContentMessage() {
      if (this.$route.name === 'RECENT') {
        return t('radio', 'No recent stations yet');
      } else if (this.$route.name === 'SEARCH') {
        return t('radio', 'No search results');
      }

      return t('radio', 'No stations here');
    },
    emptyContentIcon: function emptyContentIcon() {
      if (this.$route.name === 'RECENT') {
        return 'icon-recent';
      } else if (this.$route.name === 'SEARCH') {
        return 'icon-search';
      }

      return 'icon-radio';
    },
    emptyContentDesc: function emptyContentDesc() {
      if (this.$route.name === 'RECENT') {
        return t('radio', 'Stations you recently played will show up here');
      } else if (this.$route.name === 'SEARCH') {
        return t('radio', 'No stations were found matching your search term');
      }

      return t('radio', 'No stations here');
    }
  }),
  watch: {
    $route: 'onRoute'
  },
  mounted: function mounted() {
    this.onRoute();
    this.scroll();
  },
  methods: _objectSpread(_objectSpread({}, mapActions(['addFavorite', 'removeFavorite', 'addRecent', 'playStation'])), {}, {
    onResize: function onResize(_ref) {
      var width = _ref.width,
          height = _ref.height;
      var contentHeight = document.getElementById('app-content-vue').scrollHeight;
      var tableHeight = height;

      if (tableHeight < contentHeight) {
        this.preFill();
      }
    },
    preFill: function preFill() {
      var route = this.$route;
      this.loadStations(route.name);
    },
    onRoute: function onRoute() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var route;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.tableData = [];
                _this.pageLoading = true;
                route = _this.$route;

                _this.loadStations(route.name);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    /**
    	 * Favor a new station by sending the information to the server
    	 * @param {Object} station Station object
    	 */
    doFavor: function doFavor(station) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.isFavorite(station)) {
                  _this2.removeFavorite(station);
                } else {
                  _this2.addFavorite(station);
                }

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },

    /**
    	 * Start playing a radio station and counting the playback
    	 * @param {Object} station Station object
    	 */
    doPlay: function doPlay(station) {
      /* Start streaming station */
      this.playStation(station);
      /* Count click */

      apiClient.countClick(station);
      /* Put into recent stations */

      this.addRecent(station);
    },
    loadStations: function loadStations() {
      var _arguments = arguments,
          _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var menuState, stations, _stations;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                menuState = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 'TOP';

                if (!(_this3.tableData.length > 0 && _this3.$route.name === 'RECENT')) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return", true);

              case 3:
                if (!(menuState === 'RECENT')) {
                  _context3.next = 7;
                  break;
                }

                _this3.pageLoading = false;
                _context3.next = 21;
                break;

              case 7:
                if (!(menuState === 'SEARCH')) {
                  _context3.next = 15;
                  break;
                }

                _context3.next = 10;
                return apiClient.searchStations(_this3.$route.params.query, _this3.tableData.length);

              case 10:
                stations = _context3.sent;
                _this3.tableData = _this3.tableData.concat(stations);
                _this3.pageLoading = false;
                _context3.next = 21;
                break;

              case 15:
                if (!(menuState === 'NEW' || menuState === 'TOP')) {
                  _context3.next = 21;
                  break;
                }

                _context3.next = 18;
                return apiClient.queryList(menuState, _this3.tableData.length);

              case 18:
                _stations = _context3.sent;
                _this3.tableData = _this3.tableData.concat(_stations);
                _this3.pageLoading = false;

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },

    /**
     * On scroll event, load more stations if bottom reached
     */
    scroll: function scroll() {
      var _this4 = this;

      window.onscroll = function () {
        if (window.innerHeight + window.scrollY >= document.body.scrollHeight) {
          var route = _this4.$route;

          _this4.loadStations(route.name);
        }
      };
    },
    toggleSidebar: function toggleSidebar() {
      var station = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (station) {
        this.showSidebar = true;
        this.sidebarStation = station;
      } else {
        this.showSidebar = false;
      }
    }
  })
};